/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import IconButton from '../IconButton';

import type { Translate } from '../../types';

type Props = {
  input: Object,
  t: Translate,
};

const FieldLock = (props: Props) => {
  const { input, t, ...restProps } = props;
  const { value = false, ...restInput } = input;
  return (
    <label>
      <input
        style={{ display: 'none' }}
        type={'checkbox'}
        checked={value}
        {...restProps}
        {...restInput}
      />
      <IconButton
        icon={value ? 'lock' : 'lock_open'}
        tooltip={value ? t('LOCKED') : t('UNLOCKED')}
      />
    </label>
  );
};

export default withTranslation()(FieldLock);
